module.exports = __webpack_public_path__ + "img/singletrack-study-subscriptions.56e5642c.png";